<template>

<core-panel>

	<template v-slot:head>

		<h1>Streaks</h1>

		<p>All <b>{{ streaks.length }}</b> consecutive month streaks, longest first.</p>

	</template>

	<template v-slot:body>

		<div class="streak" v-for="(streak, index) in items" :key="index">

			<div class="streak-head">

				<div class="streak-label">{{ streak.fromLabel }} — {{ streak.toLabel }}</div>

				<div class="streak-pill" :class="streak.type === 'played' ? 'is-hot' : 'is-cold'">{{ streak.type === 'played' ? 'Hot' : 'Cold' }}</div>

			</div>

			<div class="streak-value">

				<div class="streak-count">{{ streak.months }}<small>{{ streak.months === 1 ? ' month' : ' months' }}</small></div>

			</div>

			<div class="streak-bar">

				<div class="streak-bar-fill" :class="streak.type === 'played' ? 'is-hot' : 'is-cold'" :style="{ width: barWidth(streak) + '%' }" />

			</div>

		</div>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'streaks',
			streaks: []
		}

	},

	computed: {

		maxMonths: function() {

			if (!this.streaks.length) return 0

			var max = 0

			for (var i = 0; i < this.streaks.length; i++) {

				if (this.streaks[i].months > max) max = this.streaks[i].months

			}

			return max

		},

		items: function() {

			return this.streaks

		}

	},

	methods: {

		response: function(json) {

			this.streaks = json.streaks

		},

		barWidth: function(streak) {

			return this.maxMonths ? Math.round((streak.months / this.maxMonths) * 100) : 0

		}

	}

}

</script>

<style scoped>

.streak {
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 10px 15px;
}

.streak:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.streak-head {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
}

.streak-label {
	font-size: 12px;
	font-weight: 500;
	color: #333;
	flex-grow: 1;
}

.streak-pill {
	font-size: 10px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	padding: 2px 8px;
	border-radius: 10px;
	line-height: 16px;
	flex-shrink: 0;
}

.streak-pill.is-hot {
	background-color: rgba(223, 71, 81, 0.12);
	color: #c0392b;
}

.streak-pill.is-cold {
	background-color: rgba(72, 129, 187, 0.12);
	color: #4881bb;
}

.streak-value {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 8px;
}

.streak-count {
	font-size: 22px;
	font-weight: 700;
	color: #333;
	line-height: 1;
}

.streak-count small {
	font-size: 13px;
	font-weight: 400;
	color: #999;
}

.streak-bar {
	width: 100%;
	height: 6px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 3px;
	overflow: hidden;
}

.streak-bar-fill {
	height: 100%;
	border-radius: 3px;
}

.streak-bar-fill.is-hot {
	background-color: #4881bb;
}

.streak-bar-fill.is-cold {
	background-color: #ccc;
}

</style>
